import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";

const paths = [
  {
    no: "01",
    title: "Invite Eddie",
    to: "/invite-eddie",
    line: "Bring him into your world.",
    items: [
      "Festivals",
      "Culinary events",
      "Restaurant openings",
      "Corporate events",
      "Food experiences",
      "Community events",
    ],
  },
  {
    no: "02",
    title: "Hire Eddie",
    to: "/hire-eddie",
    line: "Put him to work at the table.",
    items: [
      "Private events",
      "Culinary demonstrations",
      "Speaking",
      "Hosting",
      "Brand collaborations",
      "Special appearances",
    ],
  },
  {
    no: "03",
    title: "Submit a Locavore",
    to: "/submit-a-locavore",
    line: "Send him somewhere worth discovering.",
    items: [
      "Restaurants",
      "Chefs",
      "Farms",
      "Markets",
      "Food businesses",
      "Culinary destinations",
    ],
  },
];

export default function BringSection() {
  return (
    <section className="bg-background-50">
      <div className="w-full px-5 md:px-10 lg:px-16 py-20 md:py-28">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <Reveal>
              <p className="eyebrow">Section 04 — The Invitation</p>
            </Reveal>
            <Reveal delay={120}>
              <h2 className="mt-5 font-heading text-4xl leading-[1.02] text-foreground-950 sm:text-5xl md:text-6xl">
                BRING CHEF EDDIE G
                <br />
                <span className="italic text-primary-600">TO YOU</span>
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-5 lg:self-end">
            <Reveal delay={200}>
              <p className="font-body text-base leading-relaxed text-foreground-700 md:text-lg">
                Have an event, restaurant, food business, destination or
                culinary experience Eddie should discover? There are three ways
                to begin.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-px overflow-hidden rounded-sm bg-foreground-950/12 md:grid-cols-3">
          {paths.map((path, i) => (
            <Reveal key={path.no} delay={i * 110}>
              <div className="flex h-full flex-col bg-background-50 p-8 md:p-10">
                <span className="font-heading text-2xl italic text-primary-500">
                  {path.no}
                </span>
                <h3 className="mt-5 font-heading text-2xl text-foreground-950 md:text-3xl">
                  {path.title}
                </h3>
                <p className="mt-2 font-body text-sm italic text-foreground-600">
                  {path.line}
                </p>

                <ul className="mt-7 flex flex-1 flex-col gap-2.5">
                  {path.items.map((item) => (
                    <li
                      key={item}
                      className="font-body text-sm text-foreground-700"
                    >
                      {item}
                    </li>
                  ))}
                </ul>

                <Link
                  to={path.to}
                  className="link-underline mt-9 inline-flex w-fit items-center gap-2 font-label text-[11px] uppercase tracking-label text-primary-700"
                >
                  Begin here
                  <i className="ri-arrow-right-line text-base" />
                </Link>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={200}>
          <div className="mt-12 flex justify-center">
            <Link to="/invite-eddie" className="btn-primary">
              Send Eddie Somewhere Worth Discovering
              <i className="ri-send-plane-line text-base" />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}